(() => {
  'use strict';
  const roots = document.querySelectorAll('[data-predictive-search-root]');
  if (!roots.length) return;
  const cache = new Map();
  const escapeSelector = (value) => window.CSS?.escape ? CSS.escape(value) : value.replace(/[^a-zA-Z0-9_-]/g, '\\$&');

  roots.forEach((root) => {
    const input = root.querySelector('[data-predictive-search-input]');
    const results = root.querySelector('[data-predictive-search-results]');
    const status = root.querySelector('[data-predictive-search-status]');
    if (!input || !results) return;

    let controller;
    let timer;
    let activeIndex = -1;

    const close = () => {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    };

    const setResults = (html, term) => {
      results.innerHTML = html;
      const panel = results.querySelector('[data-predictive-search-panel]');
      if (!panel) return close();
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      const count = results.querySelectorAll('[role="option"]').length;
      if (status) status.textContent = `${count} Suchvorschläge für ${term}`;
    };

    const fetchResults = async (term) => {
      const key = term.toLocaleLowerCase();
      if (cache.has(key)) return setResults(cache.get(key), term);
      controller?.abort();
      controller = new AbortController();
      results.hidden = false;
      results.innerHTML = '<div class="predictive-search__loading" aria-hidden="true"></div>';
      try {
        const url = `${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');
        const html = section ? section.innerHTML : text;
        cache.set(key, html);
        setResults(html, term);
      } catch (error) {
        if (error.name !== 'AbortError') close();
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const term = input.value.trim();
      if (term.length < 2) return close();
      timer = window.setTimeout(() => fetchResults(term), 180);
    });

    input.addEventListener('keydown', (event) => {
      const options = [...results.querySelectorAll('[role="option"] a')];
      if (!options.length) {
        if (event.key === 'Escape') close();
        return;
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        activeIndex = event.key === 'ArrowDown' ? (activeIndex + 1) % options.length : (activeIndex - 1 + options.length) % options.length;
        options[activeIndex].focus();
      } else if (event.key === 'Escape') {
        close(); input.focus();
      }
    });

    results.addEventListener('keydown', (event) => {
      const options = [...results.querySelectorAll('[role="option"] a')];
      const index = options.indexOf(document.activeElement);
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const next = event.key === 'ArrowDown' ? (index + 1) % options.length : (index - 1 + options.length) % options.length;
        options[next].focus();
      } else if (event.key === 'Escape') {
        close(); input.focus();
      }
    });

    document.addEventListener('click', (event) => { if (!root.contains(event.target)) close(); });
    root.addEventListener('reset', close);
  });
})();
